import { Component, ReactNode } from 'react'

import AddressInput from '../../address/Address'

import Input from '../../../libs/ui/inputs/Input'

import {PersonFormProps} from "../person/PersonForm"

import * as Validation from '../contractor/ContractorRemoteValidation'

import {
    NAMES_PATTERN, EMAIL_PATTERN, PHONE_NUMBER_PATTERN,
    P_IVA_PATTERN, OBJECTS_NAMES_PATTERN
} from '../../../libs/validation/stringRegex'


interface CompanyFormProps extends PersonFormProps {
    nomeAzienda: string | undefined,
    ragioneSociale: string | undefined,
    pIva: string | undefined,

    indirizzoSedeLegale: string | undefined,

    is_manual_address?: boolean
    updateManualSelectionCallBack?: Function    // salva la scelta tra inserimento manuale o autocompletamento del utente

    updateNomeAzienda: Function
    updateRagioneSociale: Function
    updatePiva: Function
    updateIndirizzo: Function

    nomeAziendaError?: string | undefined,
    ragioneSocialeError?: string | undefined,
    pIvaError?: string | undefined,
    indirizzoSedeLegaleError?: string | undefined,

    clearNomeAziendaError?: Function
    clearRagioneSocialeError?: Function
    clearPIvaError?: Function
    clearIndirizzoSedeLegaleError?: Function
}

interface State {
    is_manual_address: boolean
}

class CompanyForm extends Component<CompanyFormProps, State> {
    
    constructor (props: any) {
        super(props)

        this.state = {
            is_manual_address: (this.props.is_manual_address !== undefined) ? this.props.is_manual_address : false
        }

        this.clearNomeAziendaError = this.clearNomeAziendaError.bind(this)
        this.clearRagioneSocialeError = this.clearRagioneSocialeError.bind(this)
        this.clearPIvaError = this.clearPIvaError.bind(this)
        this.clearIndirizzoError = this.clearIndirizzoError.bind(this)

        this.updateAll = this.updateAll.bind(this)
        this.updateStreet = this.updateStreet.bind(this)
        this.updateNumber = this.updateNumber.bind(this)
        this.updateZip = this.updateZip.bind(this)
        this.updateCity = this.updateCity.bind(this)

        this.clearNomeError = this.clearNomeError.bind(this)
        this.clearCognomeError = this.clearCognomeError.bind(this)
        this.clearEmailError = this.clearEmailError.bind(this)
        this.clearPhoneError = this.clearPhoneError.bind(this)
        this.clearProfeError = this.clearProfeError.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<CompanyFormProps>, prevState: Readonly<State>, snapshot?: any): void {
        if (
            this.props.is_manual_address !== undefined &&
            this.props.is_manual_address !== prevProps.is_manual_address &&
            this.props.is_manual_address !== this.state.is_manual_address &&
            this.props.is_manual_address !== prevState.is_manual_address
        ) {
            this.setState({
                is_manual_address: this.props.is_manual_address
            })
        }
    }

    render(): ReactNode {
        return (
            <>
                <Input 
                    id='nomeAzienda' name='nomeAzienda' 
                    label='Nome Azienda' 
                    value={this.props.nomeAzienda}
                    type='text'
                    maxLength={100}
                    callback={this.props.updateNomeAzienda}
                    regexp={OBJECTS_NAMES_PATTERN}
                    errorDisplayMsg='Nome Azienda non valido'
                    remoteValidation={Validation.companyValidation}
                    error={this.props.nomeAziendaError}
                    onFocus={this.clearNomeAziendaError}
                />

                <Input 
                    id='pIva' name='pIva' 
                    label='P.IVA' 
                    value={this.props.pIva}
                    type='text'
                    maxLength={13}
                    callback={this.props.updatePiva}
                    regexp={P_IVA_PATTERN}
                    errorDisplayMsg='Numero di Partita IVA non valido'
                    remoteValidation={Validation.pIvaValidation}
                    error={this.props.pIvaError}
                    onFocus={this.clearPIvaError}
                />

                <Input 
                    id='ragioneSociale' name='ragioneSociale' 
                    label='Ragione sociale' 
                    value={this.props.ragioneSociale}
                    type='text'
                    maxLength={100}
                    callback={this.props.updateRagioneSociale}
                    regexp={OBJECTS_NAMES_PATTERN}
                    errorDisplayMsg='Ragione sociale non valida'
                    remoteValidation={Validation.companyValidation}
                    error={this.props.ragioneSocialeError}
                    onFocus={this.clearRagioneSocialeError}
                />

                <div className='row'>
                    <AddressInput 
                        value={this.props.indirizzoSedeLegale}

                        street={this.props.street}
                        number={this.props.street_number}
                        zip={this.props.zip}
                        city={this.props.city}
                        
                        error={this.props.indirizzoResidenzaError}
                        streetError={this.props.streetError}
                        numberError={this.props.street_numberError}
                        zipError={this.props.zipError}
                        cityError={this.props.cityError}

                        updateAll={this.updateAll}
                        updateStreet={this.updateStreet}
                        updateNumber={this.updateNumber}
                        updateZip={this.updateZip}
                        updateCity={this.updateCity}

                        is_manual_address={this.state.is_manual_address}
                        updateManualSelectionCallBack={this.props.updateManualSelectionCallBack}

                        clearError={this.clearIndirizzoError}
                        clearStreetError={this.props.clearStreetError}
                        clearNumberError={this.props.clearStreet_numberError}
                        clearZipError={this.props.clearZipError}
                        clearCityError={this.props.clearCityError}

                        expiredSessionCallbak={this.props.expiredSessionCallbak}

                        isSedeLegale={true}
                    />
                </div>

                <div className='row'>

                    <div className='col-md-6 col-12'>
                        <Input 
                            id='nome' name='nome' 
                            label='Nome Referente' 
                            value={this.props.nome}
                            type='text'
                            maxLength={40}
                            callback={this.props.updateName}
                            regexp={NAMES_PATTERN}
                            errorDisplayMsg='Nome Referente non valido'
                            remoteValidation={Validation.namesValidation}
                            error={this.props.nomeError}
                            onFocus={this.clearNomeError}
                        />
                    </div>
                    <div className='col-md-6 col-12'>
                        <Input 
                            id='cognome' name='cognome' 
                            label='Cognome Referente' 
                            value={this.props.cognome}
                            type='text'
                            maxLength={40}
                            callback={this.props.updateCognome}
                            regexp={NAMES_PATTERN}
                            errorDisplayMsg='Cognome Referente non valido'
                            remoteValidation={Validation.namesValidation}
                            error={this.props.cognomeError}
                            onFocus={this.clearCognomeError}
                        />
                    </div>

                </div>

                <div className='row'>

                    <div className='col-md-6 col-12'>
                        <Input 
                            id='email' name='email' 
                            label='Email Referente' 
                            value={this.props.email}
                            type='email'
                            callback={this.props.updateEmail}
                            regexp={EMAIL_PATTERN}
                            maxLength={100}
                            errorDisplayMsg='Email non valida'
                            remoteValidation={Validation.emailsValidation}
                            error={this.props.emailError}
                            onFocus={this.clearEmailError}
                        />
                    </div>
                    <div className='col-md-6 col-12'>
                        <Input 
                            id='cellulare' name='cellulare' 
                            label='Cellulare Referente' 
                            value={this.props.cellulare}
                            type='text'
                            maxLength={10}
                            callback={this.props.updateCellulare}
                            regexp={PHONE_NUMBER_PATTERN}
                            errorDisplayMsg='Telefono non valido'
                            remoteValidation={Validation.phonesValidation}
                            error={this.props.phoneError}
                            onFocus={this.clearPhoneError}
                        />
                    </div>

                </div>
                
            </>
        )
    }

    private updateAll (
        pStreet: string | undefined | null,
        pStreet_number: string | undefined | null,
        pZip: string | undefined | null,
        pCity: string | undefined | null
    ) {
        if (this.props.updateAllAddressParts) {
            this.props.updateAllAddressParts(
                pStreet,
                pStreet_number,
                pZip,
                pCity,
            )
        }
    }
    private updateStreet (val: string | undefined) {
        if (this.props.updateStreet) {
            this.props.updateStreet( val )
        }
    }
    private updateNumber (val: string | undefined) {
        if (this.props.updateStreet_number) {
            this.props.updateStreet_number( val )
        }
    }
    private updateZip (val: string | undefined) {
        if (this.props.updateZip) {
            this.props.updateZip( val )
        }
    }
    private updateCity (val: string | undefined) {
        if (this.props.updateCity) {
            this.props.updateCity( val )
        }
    }

    private clearNomeAziendaError () {
        if (this.props.clearNomeAziendaError) {
            this.props.clearNomeAziendaError()
        }
    }
    private clearRagioneSocialeError () {
        if (this.props.clearRagioneSocialeError) {
            this.props.clearRagioneSocialeError()
        }
    }
    private clearPIvaError () {
        if (this.props.clearPIvaError) {
            this.props.clearPIvaError()
        }
    }
    private clearIndirizzoError () {
        if (this.props.clearIndirizzoResidenzaError) {
            this.props.clearIndirizzoResidenzaError()
        }
    }

    private clearNomeError () {
        if (this.props.clearNomeError) {
            this.props.clearNomeError()
        }
    }
    private clearCognomeError () {
        if (this.props.clearCognomeError) {
            this.props.clearCognomeError()
        }
    }
    private clearEmailError () {
        if (this.props.clearEmailError) {
            this.props.clearEmailError()
        }
    }
    private clearPhoneError () {
        if (this.props.clearPhoneError) {
            this.props.clearPhoneError()
        }
    }
    private clearProfeError () {
        if (this.props.clearProfeError) {
            this.props.clearProfeError()
        }
    }
}

export default CompanyForm